import { css } from "@emotion/css";
import { Callout } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { MissingPackageInfo } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import InternalLink from "~/components/Navigation/InternalLink/index";
interface MissingPackagesCalloutProps {
    spaceId: string;
    missingPackages: MissingPackageInfo[];
}
export const MissingPackagesCallout = ({ spaceId, missingPackages }: MissingPackagesCalloutProps) => {
    if (!missingPackages.length) {
        return null;
    }
    return (<Callout type={"warning"} title="One or more packages associated with this release are missing">
            <>
                This might cause the deployment to fail. Please ensure the following package(s) exist in the <InternalLink to={links.builtInPackageRepositoryPage.generateUrl({ spaceId })}>built-in-repository</InternalLink>.
                <ul className={styles.list}>
                    {missingPackages?.map((pkg, index) => (<li key={index}>
                            {pkg.Id} (Version: {pkg.Version})
                        </li>))}
                </ul>
            </>
        </Callout>);
};
const styles = {
    list: css({
        listStyleType: "disc",
        paddingLeft: space[16],
        margin: 0,
    }),
};
